import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "col-md-3 left_col"
};
const _hoisted_2 = {
    key: 2,
    class: "clearfix hide"
};
const _hoisted_3 = { class: "section" };
const _hoisted_4 = { class: "custom-template" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "custom-template-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation" })
], -1 /* HOISTED */);
const _hoisted_6 = { class: "custom-template-content" };
const _hoisted_7 = { class: "custom-template-title" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_11 = [
    _hoisted_10
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LicenseWarningBanner = _resolveComponent("LicenseWarningBanner");
    const _component_LeftMenuVue = _resolveComponent("LeftMenuVue");
    const _component_TopMenuVue = _resolveComponent("TopMenuVue");
    const _component_router_view = _resolveComponent("router-view");
    const _component_notifications = _resolveComponent("notifications");
    const _component_confirm = _resolveComponent("confirm");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.bodyClass)
    }, [
        _createCommentVNode(" License Warning Banner "),
        _createTextVNode(),
        (_ctx.renderLayout)
            ? (_openBlock(), _createBlock(_component_LicenseWarningBanner, { key: 0 }))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createCommentVNode("<ProgressPanelVue />"),
        _createTextVNode(),
        (_ctx.renderLayout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LeftMenuVue)
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        (_ctx.renderLayout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_TopMenuVue)
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createElementVNode("div", {
            class: _normalizeClass(_ctx.rightPanelClass),
            role: "main"
        }, [
            _createElementVNode("section", _hoisted_3, [
                (_openBlock(), _createBlock(_component_router_view, {
                    key: _ctx.componentKey(_ctx.$route)
                }, {
                    default: _withCtx(({ Component }) => [
                        _createVNode(_Transition, {
                            name: "component-fade",
                            mode: "out-in"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.cachedVues }, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                ], 1032 /* PROPS, DYNAMIC_SLOTS */, ["include"]))
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 1 /* STABLE */
                }))
            ])
        ], 2 /* CLASS */),
        _createTextVNode(),
        _createVNode(_component_notifications, {
            group: "global",
            position: "bottom right"
        }),
        _createTextVNode(),
        _createVNode(_component_notifications, {
            class: "payment-status-notification",
            group: "payment-status",
            duration: -1,
            width: 400,
            "animation-name": "v-fade-left",
            position: "top center",
            "dangerously-set-inner-html": ""
        }, {
            body: _withCtx(({ item, close }) => [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1 /* TEXT */),
                        _createTextVNode(),
                        _createElementVNode("div", {
                            class: "custom-template-text",
                            innerHTML: item.text
                        }, null, 8 /* PROPS */, _hoisted_8)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", {
                        class: "custom-template-close",
                        onClick: close
                    }, _hoisted_11, 8 /* PROPS */, _hoisted_9)
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _createTextVNode(),
        _createVNode(_component_confirm)
    ], 2 /* CLASS */));
}
